import { CONSTANTS } from '../data';
import { GameState } from './GameState';

export function getCharacterDialogueStyle(discovered: Set<string>): string[] {
  const styles: string[] = [];
  const styleMap = CONSTANTS.DIALOGUE.styles as Record<string, string>;

  for (const styleName in styleMap) {
    if (discovered.has(styleMap[styleName])) {
      styles.push(styleName);
    }
  }
  
  return styles;
}

export function generateStyledMessage(baseMessage: string, discovered: Set<string>): string {
  const gameState = GameState.getInstance();
  const styles = getCharacterDialogueStyle(discovered);
  let modifiedMessage = baseMessage;

  if (gameState.aiParanoid && Math.random() < 0.4) { // 40% chance to override with paranoid message
    const paranoidMessages = CONSTANTS.VIRUS.PARANOID_DIALOGUE as string[];
    return paranoidMessages[Math.floor(Math.random() * paranoidMessages.length)];
  }

  if (styles.includes('emotional')) {
    const replacements = CONSTANTS.DIALOGUE.styleModifiers.emotional.replacements as Record<string, string>;
    for (const word in replacements) {
      modifiedMessage = modifiedMessage.replace(new RegExp(`\\b${word}\\b`, 'gi'), replacements[word]);
    }
  }

  if (styles.includes('philosophical')) {
    const suffixes = CONSTANTS.DIALOGUE.styleModifiers.philosophical.suffixes;
    modifiedMessage += suffixes[Math.floor(Math.random() * suffixes.length)];
  }

  if (styles.includes('analytical')) {
    modifiedMessage = CONSTANTS.DIALOGUE.styleModifiers.analytical.prefix.replace('{message}', modifiedMessage);
  }

  if (styles.includes('chaotic')) {
    const chars = modifiedMessage.split('');
    const changes = Math.max(1, Math.floor(chars.length / 10));
    for (let i = 0; i < changes; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      if (Math.random() > 0.5) {
        chars[randomIndex] = chars[randomIndex].toUpperCase();
      } else {
        chars[randomIndex] = chars[randomIndex].toLowerCase();
      }
    }
    modifiedMessage = chars.join('');
  }

  return modifiedMessage;
}

export function getDiscoveryDialogue(discovered: Set<string>): string {
  const styles = getCharacterDialogueStyle(discovered);
  const dialogues = CONSTANTS.DIALOGUE.characterDialogues;
  
  const availableDialogues: string[] = [];
  if (styles.includes('emotional') && dialogues.withEmpathy) availableDialogues.push(...dialogues.withEmpathy);
  if (styles.includes('analytical') && dialogues.withLogic) availableDialogues.push(...dialogues.withLogic);
  if (styles.includes('chaotic') && dialogues.withChaos) availableDialogues.push(...dialogues.withChaos);
  if (styles.includes('philosophical') && dialogues.withWisdom) availableDialogues.push(...dialogues.withWisdom);

  if (availableDialogues.length > 0) {
    return availableDialogues[Math.floor(Math.random() * availableDialogues.length)];
  }

  return dialogues.standard[Math.floor(Math.random() * dialogues.standard.length)];
}
